import { useContext, useMemo, useEffect } from 'react';
import { useAppContext } from '@provider/app-context';
import { useUserIdentityState } from '@provider/user-identity';
import { EventTrackingContext } from './events/_provider.js';

const pendingEvents = /* @__PURE__ */ new Set();
function useTrackingManager() {
  var _a, _b, _c, _d;
  const args = useContext(EventTrackingContext);
  const appContext = useAppContext((state) => state);
  const userResolved = useUserIdentityState(
    (state) => state.user !== void 0
  );
  const userRole = useUserIdentityState((state) => {
    var _a2;
    return (_a2 = state.user) == null ? void 0 : _a2.role;
  }) ?? "not-logged-in";
  const context = useMemo(() => {
    var _a2, _b2;
    if (!userResolved || !((_a2 = appContext.app) == null ? void 0 : _a2.name) || !((_b2 = appContext.product) == null ? void 0 : _b2.id) || !appContext.product.audience || !appContext.product.title) {
      return void 0;
    }
    return {
      app: {
        name: appContext.app.name
      },
      product: {
        id: appContext.product.id,
        title: appContext.product.title,
        audience: appContext.product.audience
      },
      user: {
        role: userRole
      }
    };
  }, [
    (_a = appContext.app) == null ? void 0 : _a.name,
    (_b = appContext.product) == null ? void 0 : _b.audience,
    (_c = appContext.product) == null ? void 0 : _c.id,
    (_d = appContext.product) == null ? void 0 : _d.title,
    userResolved,
    userRole
  ]);
  useEffect(() => {
    if (!context) {
      return;
    }
    for (const pendingEvent of pendingEvents) {
      args.handleEvent(pendingEvent.name, pendingEvent.attributes, context);
    }
    pendingEvents.clear();
  }, [args.handleEvent, context]);
  return useMemo(
    () => ({
      trackEvent: (name, attributes) => {
        if (!context) {
          pendingEvents.add({
            name,
            attributes
          });
          return;
        }
        args.handleEvent(name, attributes, context);
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [args, args.handleEvent, context]
  );
}

export { useTrackingManager };
//# sourceMappingURL=_manager.js.map
